import * as Yup from 'yup'

import { persianTranslationRequired } from '../../../helpers/persianNameValidation'
import {
  RatePlanBasicDetailsForGenerate,
  RatePlanBasicDetailsForModify
} from '../../../types/rateplan'
import { LocationType } from '../../../types/roomtype'

export const rateplanFormValidationSchema = Yup.object({
  basicDetails: Yup.object({
    type: Yup.string().required('This field is required'),
    roomTypeCode: Yup.string().required('This field is required'),
    parentRatePlanCode: Yup.string().when('type', {
      is: (type: LocationType) => {
        return type === 'Virtual'
      },
      then: Yup.string().required('This field is required')
    }),
    name: Yup.string()
      .min(2, 'Enter a name more than 1 characters long')
      .required('This field is required'),
    nameTranslatedList: persianTranslationRequired(),
    boardType: Yup.string().when('type', {
      is: (type: LocationType) => type === 'Physical',
      then: Yup.string().required('This field is required')
    }),
    code: Yup.array().min(1).required('This field is required'),
    providerCode: Yup.string().required('This field is required'),
    ratePolicy: Yup.string().required('This field is required'),
    ratePolicyTranslatedList: Yup.array().of(
      Yup.object({
        label: Yup.string(),
        nativeLabel: Yup.string(),
        value: Yup.string().required('This field is required')
      })
    )
  }),
  supportedWalletTypes: Yup.array().when('basicDetails', {
    is: (basicDetails: RatePlanBasicDetailsForGenerate) => {
      return basicDetails.type === 'Physical'
    },
    then: Yup.array()
      .of(
        Yup.object({
          isSelected: Yup.boolean(),
          currency: Yup.string(),
          walletTypes: Yup.array()
            .of(Yup.string())
            .when('isSelected', {
              is: true,
              then: Yup.array()
                .of(Yup.string())
                .test({
                  message: 'Please select a wallet type',
                  test: (array) => (array ? array.length > 0 : true)
                })
            })
        })
      )
      .test(
        'at-least-one-selected',
        'At least one wallet type must be selected',
        (walletTypes) => {
          return walletTypes!.some((wallet) => wallet.isSelected)
        }
      )
      .required('Wallet types are required for physical type')
  })
})

export const rateplanFormValidationSchemaForModify = Yup.object({
  basicDetails: Yup.object({
    type: Yup.string().required('This field is required'),
    roomTypeCode: Yup.string().required('This field is required'),
    parentRatePlanCode: Yup.string()
      .nullable()
      .when('type', {
        is: (type: LocationType) => type === 'Virtual',
        then: Yup.string().required('This field is required')
      }),
    name: Yup.string()
      .min(2, 'Enter a name more than 1 characters long')
      .required('This field is required'),
    nameTranslatedList: persianTranslationRequired(),
    boardType: Yup.string().when('type', {
      is: (type: LocationType) => type === 'Physical',
      then: Yup.string().required('This field is required')
    }),
    code: Yup.string().required('This field is required'),
    ratePolicy: Yup.string().required('This field is required'),
    ratePolicyTranslatedList: Yup.array().of(
      Yup.object({
        label: Yup.string(),
        nativeLabel: Yup.string(),
        value: Yup.string().required('This field is required')
      })
    )
  }),
  supportedWalletTypes: Yup.array().when('basicDetails', {
    is: (basicDetails: RatePlanBasicDetailsForModify) => {
      return basicDetails.type === 'Physical'
    },
    then: Yup.array()
      .of(
        Yup.object({
          isSelected: Yup.boolean(),
          currency: Yup.string(),
          walletTypes: Yup.array()
            .of(Yup.string())
            .when('isSelected', {
              is: true,
              then: Yup.array()
                .of(Yup.string())
                .test({
                  message: 'Please select a wallet type',
                  test: (array) => (array ? array.length > 0 : true)
                })
            })
        })
      )
      .test(
        'at-least-one-selected',
        'At least one wallet type must be selected',
        (walletTypes) => {
          return walletTypes!.some((wallet) => wallet.isSelected)
        }
      )
      .required('Wallet types are required for physical type')
  })
})
